import * as Types from '../../../../../../../admin/graphql/src/lib/types';

import { InferenceStream } from '@wm-front/core'
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type FetchReferentUsersQueryVariables = Types.Exact<{
  filters: Types.ReferentUsersFilter;
  pagination?: Types.InputMaybe<Types.UsersConnectionArgs>;
}>;


export type FetchReferentUsersQuery = { __typename?: 'Query', referentUsers: { __typename?: 'UsersIUserConnection', edges: Array<{ __typename?: 'UsersIUserEdge', node: { __typename?: 'Admin', firstName?: string | null, lastName?: string | null, id?: number | null } | { __typename?: 'Customer', firstName?: string | null, lastName?: string | null, id?: number | null } | { __typename?: 'Mechanic', firstName?: string | null, lastName?: string | null, id?: number | null } }>, pageInfo: { __typename?: 'UsersPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export const FetchReferentUsersDocument = gql`
    query FetchReferentUsers($filters: ReferentUsersFilter!, $pagination: UsersConnectionArgs) {
  referentUsers(filters: $filters, pagination: $pagination) {
    edges {
      node {
        id: userId
        firstName
        lastName
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchReferentUsersGQL extends Apollo.Query<FetchReferentUsersQuery, FetchReferentUsersQueryVariables> {
    override document = FetchReferentUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }